import { render, staticRenderFns } from "./CourseSingleUpload.vue?vue&type=template&id=07940d7a&scoped=true&"
import script from "./CourseSingleUpload.vue?vue&type=script&lang=js&"
export * from "./CourseSingleUpload.vue?vue&type=script&lang=js&"
import style0 from "./CourseSingleUpload.vue?vue&type=style&index=0&id=07940d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07940d7a",
  null
  
)

export default component.exports